import { render, staticRenderFns } from "./line-pricing-import-button.vue?vue&type=template&id=8c6a23c4"
import script from "./line-pricing-import-button.vue?vue&type=script&lang=js"
export * from "./line-pricing-import-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports